import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=476c6080&scoped=true&"
import script from "./VehicleCard.vue?vue&type=script&lang=ts&"
export * from "./VehicleCard.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleCard.vue?vue&type=style&index=0&id=476c6080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c6080",
  null
  
)

export default component.exports